import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/shared/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  public mode = 'indeterminate';
  public color = 'primary';
  public isVisible: boolean = false;

  constructor(private _loaderService: LoaderService) {}

  ngOnInit() {
    this._loaderService.numberOfRequests.subscribe(count => {
      if(count > 0){
        this.isVisible = true;
      }else{
        this.isVisible = false;
      }
    });
  }

}
